const compatModules = {};import * as Mod1 from "./discourse/components/custom-field-input";
compatModules["discourse/components/custom-field-input"] = Mod1;

export * as discourse$components$custom__field__input$$__module from "./discourse/components/custom-field-input";
export {
default as discourse$components$custom__field__input$$default
} from "./discourse/components/custom-field-input";
import * as Mod2 from "./discourse/components/custom-user-selector";
compatModules["discourse/components/custom-user-selector"] = Mod2;

export * as discourse$components$custom__user__selector$$__module from "./discourse/components/custom-user-selector";
export {
default as discourse$components$custom__user__selector$$default
} from "./discourse/components/custom-user-selector";
import * as Mod3 from "./discourse/components/custom-wizard-category-selector";
compatModules["discourse/components/custom-wizard-category-selector"] = Mod3;

export * as discourse$components$custom__wizard__category__selector$$__module from "./discourse/components/custom-wizard-category-selector";
export {
default as discourse$components$custom__wizard__category__selector$$default
} from "./discourse/components/custom-wizard-category-selector";
import * as Mod4 from "./discourse/components/custom-wizard-category-settings";
compatModules["discourse/components/custom-wizard-category-settings"] = Mod4;

export * as discourse$components$custom__wizard__category__settings$$__module from "./discourse/components/custom-wizard-category-settings";
export {
default as discourse$components$custom__wizard__category__settings$$default
} from "./discourse/components/custom-wizard-category-settings";
import * as Mod5 from "./discourse/components/custom-wizard-composer-editor";
compatModules["discourse/components/custom-wizard-composer-editor"] = Mod5;

export * as discourse$components$custom__wizard__composer__editor$$__module from "./discourse/components/custom-wizard-composer-editor";
export {
wizardComposerEdtiorEventPrefix as discourse$components$custom__wizard__composer__editor$$wizardComposerEdtiorEventPrefix,
default as discourse$components$custom__wizard__composer__editor$$default
} from "./discourse/components/custom-wizard-composer-editor";
import * as Mod6 from "./discourse/components/custom-wizard-date-input";
compatModules["discourse/components/custom-wizard-date-input"] = Mod6;

export * as discourse$components$custom__wizard__date__input$$__module from "./discourse/components/custom-wizard-date-input";
export {
default as discourse$components$custom__wizard__date__input$$default
} from "./discourse/components/custom-wizard-date-input";
import * as Mod7 from "./discourse/components/custom-wizard-date-time-input";
compatModules["discourse/components/custom-wizard-date-time-input"] = Mod7;

export * as discourse$components$custom__wizard__date__time__input$$__module from "./discourse/components/custom-wizard-date-time-input";
export {
default as discourse$components$custom__wizard__date__time__input$$default
} from "./discourse/components/custom-wizard-date-time-input";
import * as Mod8 from "./discourse/components/custom-wizard-editor";
compatModules["discourse/components/custom-wizard-editor"] = Mod8;

export * as discourse$components$custom__wizard__editor$$__module from "./discourse/components/custom-wizard-editor";
export {
default as discourse$components$custom__wizard__editor$$default
} from "./discourse/components/custom-wizard-editor";
import * as Mod9 from "./discourse/components/custom-wizard-field-category";
compatModules["discourse/components/custom-wizard-field-category"] = Mod9;

export * as discourse$components$custom__wizard__field__category$$__module from "./discourse/components/custom-wizard-field-category";
export {
default as discourse$components$custom__wizard__field__category$$default
} from "./discourse/components/custom-wizard-field-category";
import * as Mod10 from "./discourse/components/custom-wizard-field-checkbox";
compatModules["discourse/components/custom-wizard-field-checkbox"] = Mod10;

export * as discourse$components$custom__wizard__field__checkbox$$__module from "./discourse/components/custom-wizard-field-checkbox";
export {
default as discourse$components$custom__wizard__field__checkbox$$default
} from "./discourse/components/custom-wizard-field-checkbox";
import * as Mod11 from "./discourse/components/custom-wizard-field-composer-preview";
compatModules["discourse/components/custom-wizard-field-composer-preview"] = Mod11;

export * as discourse$components$custom__wizard__field__composer__preview$$__module from "./discourse/components/custom-wizard-field-composer-preview";
export {
default as discourse$components$custom__wizard__field__composer__preview$$default
} from "./discourse/components/custom-wizard-field-composer-preview";
import * as Mod12 from "./discourse/components/custom-wizard-field-composer";
compatModules["discourse/components/custom-wizard-field-composer"] = Mod12;

export * as discourse$components$custom__wizard__field__composer$$__module from "./discourse/components/custom-wizard-field-composer";
export {
default as discourse$components$custom__wizard__field__composer$$default
} from "./discourse/components/custom-wizard-field-composer";
import * as Mod13 from "./discourse/components/custom-wizard-field-date-time";
compatModules["discourse/components/custom-wizard-field-date-time"] = Mod13;

export * as discourse$components$custom__wizard__field__date__time$$__module from "./discourse/components/custom-wizard-field-date-time";
export {
default as discourse$components$custom__wizard__field__date__time$$default
} from "./discourse/components/custom-wizard-field-date-time";
import * as Mod14 from "./discourse/components/custom-wizard-field-date";
compatModules["discourse/components/custom-wizard-field-date"] = Mod14;

export * as discourse$components$custom__wizard__field__date$$__module from "./discourse/components/custom-wizard-field-date";
export {
default as discourse$components$custom__wizard__field__date$$default
} from "./discourse/components/custom-wizard-field-date";
import * as Mod15 from "./discourse/components/custom-wizard-field-dropdown";
compatModules["discourse/components/custom-wizard-field-dropdown"] = Mod15;

export * as discourse$components$custom__wizard__field__dropdown$$__module from "./discourse/components/custom-wizard-field-dropdown";
export {
default as discourse$components$custom__wizard__field__dropdown$$default
} from "./discourse/components/custom-wizard-field-dropdown";
import * as Mod16 from "./discourse/components/custom-wizard-field-group";
compatModules["discourse/components/custom-wizard-field-group"] = Mod16;

export * as discourse$components$custom__wizard__field__group$$__module from "./discourse/components/custom-wizard-field-group";
export {
default as discourse$components$custom__wizard__field__group$$default
} from "./discourse/components/custom-wizard-field-group";
import * as Mod17 from "./discourse/components/custom-wizard-field-number";
compatModules["discourse/components/custom-wizard-field-number"] = Mod17;

export * as discourse$components$custom__wizard__field__number$$__module from "./discourse/components/custom-wizard-field-number";
export {
default as discourse$components$custom__wizard__field__number$$default
} from "./discourse/components/custom-wizard-field-number";
import * as Mod18 from "./discourse/components/custom-wizard-field-tag";
compatModules["discourse/components/custom-wizard-field-tag"] = Mod18;

export * as discourse$components$custom__wizard__field__tag$$__module from "./discourse/components/custom-wizard-field-tag";
export {
default as discourse$components$custom__wizard__field__tag$$default
} from "./discourse/components/custom-wizard-field-tag";
import * as Mod19 from "./discourse/components/custom-wizard-field-text";
compatModules["discourse/components/custom-wizard-field-text"] = Mod19;

export * as discourse$components$custom__wizard__field__text$$__module from "./discourse/components/custom-wizard-field-text";
export {
default as discourse$components$custom__wizard__field__text$$default
} from "./discourse/components/custom-wizard-field-text";
import * as Mod20 from "./discourse/components/custom-wizard-field-textarea";
compatModules["discourse/components/custom-wizard-field-textarea"] = Mod20;

export * as discourse$components$custom__wizard__field__textarea$$__module from "./discourse/components/custom-wizard-field-textarea";
export {
default as discourse$components$custom__wizard__field__textarea$$default
} from "./discourse/components/custom-wizard-field-textarea";
import * as Mod21 from "./discourse/components/custom-wizard-field-time";
compatModules["discourse/components/custom-wizard-field-time"] = Mod21;

export * as discourse$components$custom__wizard__field__time$$__module from "./discourse/components/custom-wizard-field-time";
export {
default as discourse$components$custom__wizard__field__time$$default
} from "./discourse/components/custom-wizard-field-time";
import * as Mod22 from "./discourse/components/custom-wizard-field-topic";
compatModules["discourse/components/custom-wizard-field-topic"] = Mod22;

export * as discourse$components$custom__wizard__field__topic$$__module from "./discourse/components/custom-wizard-field-topic";
export {
default as discourse$components$custom__wizard__field__topic$$default
} from "./discourse/components/custom-wizard-field-topic";
import * as Mod23 from "./discourse/components/custom-wizard-field-upload";
compatModules["discourse/components/custom-wizard-field-upload"] = Mod23;

export * as discourse$components$custom__wizard__field__upload$$__module from "./discourse/components/custom-wizard-field-upload";
export {
default as discourse$components$custom__wizard__field__upload$$default
} from "./discourse/components/custom-wizard-field-upload";
import * as Mod24 from "./discourse/components/custom-wizard-field-url";
compatModules["discourse/components/custom-wizard-field-url"] = Mod24;

export * as discourse$components$custom__wizard__field__url$$__module from "./discourse/components/custom-wizard-field-url";
export {
default as discourse$components$custom__wizard__field__url$$default
} from "./discourse/components/custom-wizard-field-url";
import * as Mod25 from "./discourse/components/custom-wizard-field-user-selector";
compatModules["discourse/components/custom-wizard-field-user-selector"] = Mod25;

export * as discourse$components$custom__wizard__field__user__selector$$__module from "./discourse/components/custom-wizard-field-user-selector";
export {
default as discourse$components$custom__wizard__field__user__selector$$default
} from "./discourse/components/custom-wizard-field-user-selector";
import * as Mod26 from "./discourse/components/custom-wizard-field";
compatModules["discourse/components/custom-wizard-field"] = Mod26;

export * as discourse$components$custom__wizard__field$$__module from "./discourse/components/custom-wizard-field";
export {
default as discourse$components$custom__wizard__field$$default
} from "./discourse/components/custom-wizard-field";
import * as Mod27 from "./discourse/components/custom-wizard-group-selector";
compatModules["discourse/components/custom-wizard-group-selector"] = Mod27;

export * as discourse$components$custom__wizard__group__selector$$__module from "./discourse/components/custom-wizard-group-selector";
export {
default as discourse$components$custom__wizard__group__selector$$default
} from "./discourse/components/custom-wizard-group-selector";
import * as Mod28 from "./discourse/components/custom-wizard-no-access";
compatModules["discourse/components/custom-wizard-no-access"] = Mod28;

export * as discourse$components$custom__wizard__no__access$$__module from "./discourse/components/custom-wizard-no-access";
export {
default as discourse$components$custom__wizard__no__access$$default
} from "./discourse/components/custom-wizard-no-access";
import * as Mod29 from "./discourse/components/custom-wizard-similar-topic";
compatModules["discourse/components/custom-wizard-similar-topic"] = Mod29;

export * as discourse$components$custom__wizard__similar__topic$$__module from "./discourse/components/custom-wizard-similar-topic";
export {
default as discourse$components$custom__wizard__similar__topic$$default
} from "./discourse/components/custom-wizard-similar-topic";
import * as Mod30 from "./discourse/components/custom-wizard-similar-topics";
compatModules["discourse/components/custom-wizard-similar-topics"] = Mod30;

export * as discourse$components$custom__wizard__similar__topics$$__module from "./discourse/components/custom-wizard-similar-topics";
export {
default as discourse$components$custom__wizard__similar__topics$$default
} from "./discourse/components/custom-wizard-similar-topics";
import * as Mod31 from "./discourse/components/custom-wizard-step-form";
compatModules["discourse/components/custom-wizard-step-form"] = Mod31;

export * as discourse$components$custom__wizard__step__form$$__module from "./discourse/components/custom-wizard-step-form";
export {
default as discourse$components$custom__wizard__step__form$$default
} from "./discourse/components/custom-wizard-step-form";
import * as Mod32 from "./discourse/components/custom-wizard-step";
compatModules["discourse/components/custom-wizard-step"] = Mod32;

export * as discourse$components$custom__wizard__step$$__module from "./discourse/components/custom-wizard-step";
export {
default as discourse$components$custom__wizard__step$$default
} from "./discourse/components/custom-wizard-step";
import * as Mod33 from "./discourse/components/custom-wizard-tag-chooser";
compatModules["discourse/components/custom-wizard-tag-chooser"] = Mod33;

export * as discourse$components$custom__wizard__tag__chooser$$__module from "./discourse/components/custom-wizard-tag-chooser";
export {
default as discourse$components$custom__wizard__tag__chooser$$default
} from "./discourse/components/custom-wizard-tag-chooser";
import * as Mod34 from "./discourse/components/custom-wizard-tag-selector";
compatModules["discourse/components/custom-wizard-tag-selector"] = Mod34;

export * as discourse$components$custom__wizard__tag__selector$$__module from "./discourse/components/custom-wizard-tag-selector";
export {
default as discourse$components$custom__wizard__tag__selector$$default
} from "./discourse/components/custom-wizard-tag-selector";
import * as Mod35 from "./discourse/components/custom-wizard-text-field";
compatModules["discourse/components/custom-wizard-text-field"] = Mod35;

export * as discourse$components$custom__wizard__text__field$$__module from "./discourse/components/custom-wizard-text-field";
export {
default as discourse$components$custom__wizard__text__field$$default
} from "./discourse/components/custom-wizard-text-field";
import * as Mod36 from "./discourse/components/custom-wizard-textarea-editor";
compatModules["discourse/components/custom-wizard-textarea-editor"] = Mod36;

export * as discourse$components$custom__wizard__textarea__editor$$__module from "./discourse/components/custom-wizard-textarea-editor";
export {
default as discourse$components$custom__wizard__textarea__editor$$default
} from "./discourse/components/custom-wizard-textarea-editor";
import * as Mod37 from "./discourse/components/custom-wizard-time-input";
compatModules["discourse/components/custom-wizard-time-input"] = Mod37;

export * as discourse$components$custom__wizard__time__input$$__module from "./discourse/components/custom-wizard-time-input";
export {
default as discourse$components$custom__wizard__time__input$$default
} from "./discourse/components/custom-wizard-time-input";
import * as Mod38 from "./discourse/components/custom-wizard-topic-selector";
compatModules["discourse/components/custom-wizard-topic-selector"] = Mod38;

export * as discourse$components$custom__wizard__topic__selector$$__module from "./discourse/components/custom-wizard-topic-selector";
export {
default as discourse$components$custom__wizard__topic__selector$$default
} from "./discourse/components/custom-wizard-topic-selector";
import * as Mod39 from "./discourse/components/field-validators";
compatModules["discourse/components/field-validators"] = Mod39;

export * as discourse$components$field__validators$$__module from "./discourse/components/field-validators";
export {
default as discourse$components$field__validators$$default
} from "./discourse/components/field-validators";
import * as Mod40 from "./discourse/components/modal/admin-wizards-columns";
compatModules["discourse/components/modal/admin-wizards-columns"] = Mod40;

export * as discourse$components$modal$admin__wizards__columns$$__module from "./discourse/components/modal/admin-wizards-columns";
export {
default as discourse$components$modal$admin__wizards__columns$$default
} from "./discourse/components/modal/admin-wizards-columns";
import * as Mod41 from "./discourse/components/modal/next-session-scheduled";
compatModules["discourse/components/modal/next-session-scheduled"] = Mod41;

export * as discourse$components$modal$next__session__scheduled$$__module from "./discourse/components/modal/next-session-scheduled";
export {
default as discourse$components$modal$next__session__scheduled$$default
} from "./discourse/components/modal/next-session-scheduled";
import * as Mod42 from "./discourse/components/similar-topics-validator";
compatModules["discourse/components/similar-topics-validator"] = Mod42;

export * as discourse$components$similar__topics__validator$$__module from "./discourse/components/similar-topics-validator";
export {
default as discourse$components$similar__topics__validator$$default
} from "./discourse/components/similar-topics-validator";
import * as Mod43 from "./discourse/components/validator";
compatModules["discourse/components/validator"] = Mod43;

export * as discourse$components$validator$$__module from "./discourse/components/validator";
export {
default as discourse$components$validator$$default
} from "./discourse/components/validator";
import * as Mod44 from "./discourse/components/wizard-custom-action";
compatModules["discourse/components/wizard-custom-action"] = Mod44;

export * as discourse$components$wizard__custom__action$$__module from "./discourse/components/wizard-custom-action";
export {
default as discourse$components$wizard__custom__action$$default
} from "./discourse/components/wizard-custom-action";
import * as Mod45 from "./discourse/components/wizard-custom-field";
compatModules["discourse/components/wizard-custom-field"] = Mod45;

export * as discourse$components$wizard__custom__field$$__module from "./discourse/components/wizard-custom-field";
export {
default as discourse$components$wizard__custom__field$$default
} from "./discourse/components/wizard-custom-field";
import * as Mod46 from "./discourse/components/wizard-custom-step";
compatModules["discourse/components/wizard-custom-step"] = Mod46;

export * as discourse$components$wizard__custom__step$$__module from "./discourse/components/wizard-custom-step";
export {
default as discourse$components$wizard__custom__step$$default
} from "./discourse/components/wizard-custom-step";
import * as Mod47 from "./discourse/components/wizard-links";
compatModules["discourse/components/wizard-links"] = Mod47;

export * as discourse$components$wizard__links$$__module from "./discourse/components/wizard-links";
export {
default as discourse$components$wizard__links$$default
} from "./discourse/components/wizard-links";
import * as Mod48 from "./discourse/components/wizard-mapper-connector";
compatModules["discourse/components/wizard-mapper-connector"] = Mod48;

export * as discourse$components$wizard__mapper__connector$$__module from "./discourse/components/wizard-mapper-connector";
export {
default as discourse$components$wizard__mapper__connector$$default
} from "./discourse/components/wizard-mapper-connector";
import * as Mod49 from "./discourse/components/wizard-mapper-input";
compatModules["discourse/components/wizard-mapper-input"] = Mod49;

export * as discourse$components$wizard__mapper__input$$__module from "./discourse/components/wizard-mapper-input";
export {
default as discourse$components$wizard__mapper__input$$default
} from "./discourse/components/wizard-mapper-input";
import * as Mod50 from "./discourse/components/wizard-mapper-pair";
compatModules["discourse/components/wizard-mapper-pair"] = Mod50;

export * as discourse$components$wizard__mapper__pair$$__module from "./discourse/components/wizard-mapper-pair";
export {
default as discourse$components$wizard__mapper__pair$$default
} from "./discourse/components/wizard-mapper-pair";
import * as Mod51 from "./discourse/components/wizard-mapper-selector-type";
compatModules["discourse/components/wizard-mapper-selector-type"] = Mod51;

export * as discourse$components$wizard__mapper__selector__type$$__module from "./discourse/components/wizard-mapper-selector-type";
export {
default as discourse$components$wizard__mapper__selector__type$$default
} from "./discourse/components/wizard-mapper-selector-type";
import * as Mod52 from "./discourse/components/wizard-mapper-selector";
compatModules["discourse/components/wizard-mapper-selector"] = Mod52;

export * as discourse$components$wizard__mapper__selector$$__module from "./discourse/components/wizard-mapper-selector";
export {
default as discourse$components$wizard__mapper__selector$$default
} from "./discourse/components/wizard-mapper-selector";
import * as Mod53 from "./discourse/components/wizard-mapper";
compatModules["discourse/components/wizard-mapper"] = Mod53;

export * as discourse$components$wizard__mapper$$__module from "./discourse/components/wizard-mapper";
export {
default as discourse$components$wizard__mapper$$default
} from "./discourse/components/wizard-mapper";
import * as Mod54 from "./discourse/components/wizard-message";
compatModules["discourse/components/wizard-message"] = Mod54;

export * as discourse$components$wizard__message$$__module from "./discourse/components/wizard-message";
export {
default as discourse$components$wizard__message$$default
} from "./discourse/components/wizard-message";
import * as Mod55 from "./discourse/components/wizard-realtime-validations";
compatModules["discourse/components/wizard-realtime-validations"] = Mod55;

export * as discourse$components$wizard__realtime__validations$$__module from "./discourse/components/wizard-realtime-validations";
export {
default as discourse$components$wizard__realtime__validations$$default
} from "./discourse/components/wizard-realtime-validations";
import * as Mod56 from "./discourse/components/wizard-subscription-badge";
compatModules["discourse/components/wizard-subscription-badge"] = Mod56;

export * as discourse$components$wizard__subscription__badge$$__module from "./discourse/components/wizard-subscription-badge";
export {
default as discourse$components$wizard__subscription__badge$$default
} from "./discourse/components/wizard-subscription-badge";
import * as Mod57 from "./discourse/components/wizard-subscription-selector";
compatModules["discourse/components/wizard-subscription-selector"] = Mod57;

export * as discourse$components$wizard__subscription__selector$$__module from "./discourse/components/wizard-subscription-selector";
export {
default as discourse$components$wizard__subscription__selector$$default
} from "./discourse/components/wizard-subscription-selector";
import * as Mod58 from "./discourse/components/wizard-subscription-selector/wizard-subscription-selector-header";
compatModules["discourse/components/wizard-subscription-selector/wizard-subscription-selector-header"] = Mod58;

export * as discourse$components$wizard__subscription__selector$wizard__subscription__selector__header$$__module from "./discourse/components/wizard-subscription-selector/wizard-subscription-selector-header";
export {
default as discourse$components$wizard__subscription__selector$wizard__subscription__selector__header$$default
} from "./discourse/components/wizard-subscription-selector/wizard-subscription-selector-header";
import * as Mod59 from "./discourse/components/wizard-subscription-selector/wizard-subscription-selector-row";
compatModules["discourse/components/wizard-subscription-selector/wizard-subscription-selector-row"] = Mod59;

export * as discourse$components$wizard__subscription__selector$wizard__subscription__selector__row$$__module from "./discourse/components/wizard-subscription-selector/wizard-subscription-selector-row";
export {
default as discourse$components$wizard__subscription__selector$wizard__subscription__selector__row$$default
} from "./discourse/components/wizard-subscription-selector/wizard-subscription-selector-row";
import * as Mod60 from "./discourse/components/wizard-subscription-status";
compatModules["discourse/components/wizard-subscription-status"] = Mod60;

export * as discourse$components$wizard__subscription__status$$__module from "./discourse/components/wizard-subscription-status";
export {
default as discourse$components$wizard__subscription__status$$default
} from "./discourse/components/wizard-subscription-status";
import * as Mod61 from "./discourse/components/wizard-table-field";
compatModules["discourse/components/wizard-table-field"] = Mod61;

export * as discourse$components$wizard__table__field$$__module from "./discourse/components/wizard-table-field";
export {
default as discourse$components$wizard__table__field$$default
} from "./discourse/components/wizard-table-field";
import * as Mod62 from "./discourse/components/wizard-text-editor";
compatModules["discourse/components/wizard-text-editor"] = Mod62;

export * as discourse$components$wizard__text__editor$$__module from "./discourse/components/wizard-text-editor";
export {
default as discourse$components$wizard__text__editor$$default
} from "./discourse/components/wizard-text-editor";
import * as Mod63 from "./discourse/components/wizard-user-chooser";
compatModules["discourse/components/wizard-user-chooser"] = Mod63;

export * as discourse$components$wizard__user__chooser$$__module from "./discourse/components/wizard-user-chooser";
export {
WIZARD_USER as discourse$components$wizard__user__chooser$$WIZARD_USER,
default as discourse$components$wizard__user__chooser$$default
} from "./discourse/components/wizard-user-chooser";
import * as Mod64 from "./discourse/components/wizard-user-chooser/wizard-user-chooser-row";
compatModules["discourse/components/wizard-user-chooser/wizard-user-chooser-row"] = Mod64;

export * as discourse$components$wizard__user__chooser$wizard__user__chooser__row$$__module from "./discourse/components/wizard-user-chooser/wizard-user-chooser-row";
export {
default as discourse$components$wizard__user__chooser$wizard__user__chooser__row$$default
} from "./discourse/components/wizard-user-chooser/wizard-user-chooser-row";
import * as Mod65 from "./discourse/components/wizard-value-list";
compatModules["discourse/components/wizard-value-list"] = Mod65;

export * as discourse$components$wizard__value__list$$__module from "./discourse/components/wizard-value-list";
export {
default as discourse$components$wizard__value__list$$default
} from "./discourse/components/wizard-value-list";
import * as Mod66 from "./discourse/connectors/admin-menu/wizards-nav-button.hbs";
compatModules["discourse/templates/connectors/admin-menu/wizards-nav-button"] = Mod66;

export * as discourse$templates$connectors$admin__menu$wizards__nav__button$$__module from "./discourse/connectors/admin-menu/wizards-nav-button.hbs";
export {
default as discourse$templates$connectors$admin__menu$wizards__nav__button$$default
} from "./discourse/connectors/admin-menu/wizards-nav-button.hbs";
import * as Mod67 from "./discourse/connectors/admin-user-details/admin-user-wizard-details.hbs";
compatModules["discourse/templates/connectors/admin-user-details/admin-user-wizard-details"] = Mod67;

export * as discourse$templates$connectors$admin__user__details$admin__user__wizard__details$$__module from "./discourse/connectors/admin-user-details/admin-user-wizard-details.hbs";
export {
default as discourse$templates$connectors$admin__user__details$admin__user__wizard__details$$default
} from "./discourse/connectors/admin-user-details/admin-user-wizard-details.hbs";
import * as Mod68 from "./discourse/connectors/category-custom-settings/custom-wizard-category-settings.hbs";
compatModules["discourse/templates/connectors/category-custom-settings/custom-wizard-category-settings"] = Mod68;

export * as discourse$templates$connectors$category__custom__settings$custom__wizard__category__settings$$__module from "./discourse/connectors/category-custom-settings/custom-wizard-category-settings.hbs";
export {
default as discourse$templates$connectors$category__custom__settings$custom__wizard__category__settings$$default
} from "./discourse/connectors/category-custom-settings/custom-wizard-category-settings.hbs";
import * as Mod69 from "./discourse/connectors/top-notices/prompt-completion.hbs";
compatModules["discourse/templates/connectors/top-notices/prompt-completion"] = Mod69;

export * as discourse$templates$connectors$top__notices$prompt__completion$$__module from "./discourse/connectors/top-notices/prompt-completion.hbs";
export {
default as discourse$templates$connectors$top__notices$prompt__completion$$default
} from "./discourse/connectors/top-notices/prompt-completion.hbs";
import * as Mod70 from "./discourse/connectors/top-notices/prompt-completion.js";
compatModules["discourse/connectors/top-notices/prompt-completion"] = Mod70;

export * as discourse$connectors$top__notices$prompt__completion$$__module from "./discourse/connectors/top-notices/prompt-completion.js";
export {
default as discourse$connectors$top__notices$prompt__completion$$default
} from "./discourse/connectors/top-notices/prompt-completion.js";
import * as Mod71 from "./discourse/controllers/admin-wizards-api-show";
compatModules["discourse/controllers/admin-wizards-api-show"] = Mod71;

export * as discourse$controllers$admin__wizards__api__show$$__module from "./discourse/controllers/admin-wizards-api-show";
export {
default as discourse$controllers$admin__wizards__api__show$$default
} from "./discourse/controllers/admin-wizards-api-show";
import * as Mod72 from "./discourse/controllers/admin-wizards-custom-fields";
compatModules["discourse/controllers/admin-wizards-custom-fields"] = Mod72;

export * as discourse$controllers$admin__wizards__custom__fields$$__module from "./discourse/controllers/admin-wizards-custom-fields";
export {
default as discourse$controllers$admin__wizards__custom__fields$$default
} from "./discourse/controllers/admin-wizards-custom-fields";
import * as Mod73 from "./discourse/controllers/admin-wizards-logs-show";
compatModules["discourse/controllers/admin-wizards-logs-show"] = Mod73;

export * as discourse$controllers$admin__wizards__logs__show$$__module from "./discourse/controllers/admin-wizards-logs-show";
export {
default as discourse$controllers$admin__wizards__logs__show$$default
} from "./discourse/controllers/admin-wizards-logs-show";
import * as Mod74 from "./discourse/controllers/admin-wizards-logs";
compatModules["discourse/controllers/admin-wizards-logs"] = Mod74;

export * as discourse$controllers$admin__wizards__logs$$__module from "./discourse/controllers/admin-wizards-logs";
export {
default as discourse$controllers$admin__wizards__logs$$default
} from "./discourse/controllers/admin-wizards-logs";
import * as Mod75 from "./discourse/controllers/admin-wizards-manager";
compatModules["discourse/controllers/admin-wizards-manager"] = Mod75;

export * as discourse$controllers$admin__wizards__manager$$__module from "./discourse/controllers/admin-wizards-manager";
export {
default as discourse$controllers$admin__wizards__manager$$default
} from "./discourse/controllers/admin-wizards-manager";
import * as Mod76 from "./discourse/controllers/admin-wizards-submissions-show";
compatModules["discourse/controllers/admin-wizards-submissions-show"] = Mod76;

export * as discourse$controllers$admin__wizards__submissions__show$$__module from "./discourse/controllers/admin-wizards-submissions-show";
export {
default as discourse$controllers$admin__wizards__submissions__show$$default
} from "./discourse/controllers/admin-wizards-submissions-show";
import * as Mod77 from "./discourse/controllers/admin-wizards-submissions";
compatModules["discourse/controllers/admin-wizards-submissions"] = Mod77;

export * as discourse$controllers$admin__wizards__submissions$$__module from "./discourse/controllers/admin-wizards-submissions";
export {
default as discourse$controllers$admin__wizards__submissions$$default
} from "./discourse/controllers/admin-wizards-submissions";
import * as Mod78 from "./discourse/controllers/admin-wizards-wizard-show";
compatModules["discourse/controllers/admin-wizards-wizard-show"] = Mod78;

export * as discourse$controllers$admin__wizards__wizard__show$$__module from "./discourse/controllers/admin-wizards-wizard-show";
export {
default as discourse$controllers$admin__wizards__wizard__show$$default
} from "./discourse/controllers/admin-wizards-wizard-show";
import * as Mod79 from "./discourse/controllers/admin-wizards-wizard";
compatModules["discourse/controllers/admin-wizards-wizard"] = Mod79;

export * as discourse$controllers$admin__wizards__wizard$$__module from "./discourse/controllers/admin-wizards-wizard";
export {
default as discourse$controllers$admin__wizards__wizard$$default
} from "./discourse/controllers/admin-wizards-wizard";
import * as Mod80 from "./discourse/controllers/admin-wizards";
compatModules["discourse/controllers/admin-wizards"] = Mod80;

export * as discourse$controllers$admin__wizards$$__module from "./discourse/controllers/admin-wizards";
export {
default as discourse$controllers$admin__wizards$$default
} from "./discourse/controllers/admin-wizards";
import * as Mod81 from "./discourse/controllers/custom-wizard-index";
compatModules["discourse/controllers/custom-wizard-index"] = Mod81;

export * as discourse$controllers$custom__wizard__index$$__module from "./discourse/controllers/custom-wizard-index";
export {
default as discourse$controllers$custom__wizard__index$$default
} from "./discourse/controllers/custom-wizard-index";
import * as Mod82 from "./discourse/controllers/custom-wizard-step";
compatModules["discourse/controllers/custom-wizard-step"] = Mod82;

export * as discourse$controllers$custom__wizard__step$$__module from "./discourse/controllers/custom-wizard-step";
export {
default as discourse$controllers$custom__wizard__step$$default
} from "./discourse/controllers/custom-wizard-step";
import * as Mod83 from "./discourse/controllers/custom-wizard";
compatModules["discourse/controllers/custom-wizard"] = Mod83;

export * as discourse$controllers$custom__wizard$$__module from "./discourse/controllers/custom-wizard";
export {
default as discourse$controllers$custom__wizard$$default
} from "./discourse/controllers/custom-wizard";
import * as Mod84 from "./discourse/custom-wizard-admin-route-map";
compatModules["discourse/custom-wizard-admin-route-map"] = Mod84;

export * as discourse$custom__wizard__admin__route__map$$__module from "./discourse/custom-wizard-admin-route-map";
export {
default as discourse$custom__wizard__admin__route__map$$default
} from "./discourse/custom-wizard-admin-route-map";
import * as Mod85 from "./discourse/custom-wizard-route-map";
compatModules["discourse/custom-wizard-route-map"] = Mod85;

export * as discourse$custom__wizard__route__map$$__module from "./discourse/custom-wizard-route-map";
export {
default as discourse$custom__wizard__route__map$$default
} from "./discourse/custom-wizard-route-map";
import * as Mod86 from "./discourse/helpers/wizard-char-counter";
compatModules["discourse/helpers/wizard-char-counter"] = Mod86;

export * as discourse$helpers$wizard__char__counter$$__module from "./discourse/helpers/wizard-char-counter";
export {
default as discourse$helpers$wizard__char__counter$$default
} from "./discourse/helpers/wizard-char-counter";
import * as Mod87 from "./discourse/initializers/custom-wizard-dynamic-schema";
compatModules["discourse/initializers/custom-wizard-dynamic-schema"] = Mod87;

export * as discourse$initializers$custom__wizard__dynamic__schema$$__module from "./discourse/initializers/custom-wizard-dynamic-schema";
export {
default as discourse$initializers$custom__wizard__dynamic__schema$$default
} from "./discourse/initializers/custom-wizard-dynamic-schema";
import * as Mod88 from "./discourse/initializers/custom-wizard-edits";
compatModules["discourse/initializers/custom-wizard-edits"] = Mod88;

export * as discourse$initializers$custom__wizard__edits$$__module from "./discourse/initializers/custom-wizard-edits";
export {
default as discourse$initializers$custom__wizard__edits$$default
} from "./discourse/initializers/custom-wizard-edits";
import * as Mod89 from "./discourse/initializers/custom-wizard-redirect";
compatModules["discourse/initializers/custom-wizard-redirect"] = Mod89;

export * as discourse$initializers$custom__wizard__redirect$$__module from "./discourse/initializers/custom-wizard-redirect";
export {
default as discourse$initializers$custom__wizard__redirect$$default
} from "./discourse/initializers/custom-wizard-redirect";
import * as Mod90 from "./discourse/lib/wizard-json";
compatModules["discourse/lib/wizard-json"] = Mod90;

export * as discourse$lib$wizard__json$$__module from "./discourse/lib/wizard-json";
export {
buildProperties as discourse$lib$wizard__json$$buildProperties,
present as discourse$lib$wizard__json$$present,
mapped as discourse$lib$wizard__json$$mapped
} from "./discourse/lib/wizard-json";
import * as Mod91 from "./discourse/lib/wizard-mapper";
compatModules["discourse/lib/wizard-mapper"] = Mod91;

export * as discourse$lib$wizard__mapper$$__module from "./discourse/lib/wizard-mapper";
export {
defaultInputType as discourse$lib$wizard__mapper$$defaultInputType,
defaultSelectionType as discourse$lib$wizard__mapper$$defaultSelectionType,
defaultConnector as discourse$lib$wizard__mapper$$defaultConnector,
connectorContent as discourse$lib$wizard__mapper$$connectorContent,
inputTypesContent as discourse$lib$wizard__mapper$$inputTypesContent,
selectionTypes as discourse$lib$wizard__mapper$$selectionTypes,
newInput as discourse$lib$wizard__mapper$$newInput,
newPair as discourse$lib$wizard__mapper$$newPair
} from "./discourse/lib/wizard-mapper";
import * as Mod92 from "./discourse/lib/wizard-schema";
compatModules["discourse/lib/wizard-schema"] = Mod92;

export * as discourse$lib$wizard__schema$$__module from "./discourse/lib/wizard-schema";
export {
buildFieldTypes as discourse$lib$wizard__schema$$buildFieldTypes,
buildFieldValidations as discourse$lib$wizard__schema$$buildFieldValidations,
filterValues as discourse$lib$wizard__schema$$filterValues,
setWizardDefaults as discourse$lib$wizard__schema$$setWizardDefaults,
default as discourse$lib$wizard__schema$$default
} from "./discourse/lib/wizard-schema";
import * as Mod93 from "./discourse/lib/wizard-submission";
compatModules["discourse/lib/wizard-submission"] = Mod93;

export * as discourse$lib$wizard__submission$$__module from "./discourse/lib/wizard-submission";
export {
formatModel as discourse$lib$wizard__submission$$formatModel
} from "./discourse/lib/wizard-submission";
import * as Mod94 from "./discourse/lib/wizard";
compatModules["discourse/lib/wizard"] = Mod94;

export * as discourse$lib$wizard$$__module from "./discourse/lib/wizard";
export {
selectKitContent as discourse$lib$wizard$$selectKitContent,
generateName as discourse$lib$wizard$$generateName,
generateId as discourse$lib$wizard$$generateId,
camelCase as discourse$lib$wizard$$camelCase,
snakeCase as discourse$lib$wizard$$snakeCase,
userProperties as discourse$lib$wizard$$userProperties,
listProperties as discourse$lib$wizard$$listProperties,
notificationLevels as discourse$lib$wizard$$notificationLevels,
wizardFieldList as discourse$lib$wizard$$wizardFieldList,
sentenceCase as discourse$lib$wizard$$sentenceCase,
translationOrText as discourse$lib$wizard$$translationOrText
} from "./discourse/lib/wizard";
import * as Mod95 from "./discourse/mixins/subscription";
compatModules["discourse/mixins/subscription"] = Mod95;

export * as discourse$mixins$subscription$$__module from "./discourse/mixins/subscription";
export {
default as discourse$mixins$subscription$$default
} from "./discourse/mixins/subscription";
import * as Mod96 from "./discourse/mixins/undo-changes";
compatModules["discourse/mixins/undo-changes"] = Mod96;

export * as discourse$mixins$undo__changes$$__module from "./discourse/mixins/undo-changes";
export {
default as discourse$mixins$undo__changes$$default
} from "./discourse/mixins/undo-changes";
import * as Mod97 from "./discourse/mixins/valid-state";
compatModules["discourse/mixins/valid-state"] = Mod97;

export * as discourse$mixins$valid__state$$__module from "./discourse/mixins/valid-state";
export {
States as discourse$mixins$valid__state$$States,
default as discourse$mixins$valid__state$$default
} from "./discourse/mixins/valid-state";
import * as Mod98 from "./discourse/models/custom-wizard-admin";
compatModules["discourse/models/custom-wizard-admin"] = Mod98;

export * as discourse$models$custom__wizard__admin$$__module from "./discourse/models/custom-wizard-admin";
export {
default as discourse$models$custom__wizard__admin$$default
} from "./discourse/models/custom-wizard-admin";
import * as Mod99 from "./discourse/models/custom-wizard-api";
compatModules["discourse/models/custom-wizard-api"] = Mod99;

export * as discourse$models$custom__wizard__api$$__module from "./discourse/models/custom-wizard-api";
export {
default as discourse$models$custom__wizard__api$$default
} from "./discourse/models/custom-wizard-api";
import * as Mod100 from "./discourse/models/custom-wizard-custom-field";
compatModules["discourse/models/custom-wizard-custom-field"] = Mod100;

export * as discourse$models$custom__wizard__custom__field$$__module from "./discourse/models/custom-wizard-custom-field";
export {
default as discourse$models$custom__wizard__custom__field$$default
} from "./discourse/models/custom-wizard-custom-field";
import * as Mod101 from "./discourse/models/custom-wizard-field";
compatModules["discourse/models/custom-wizard-field"] = Mod101;

export * as discourse$models$custom__wizard__field$$__module from "./discourse/models/custom-wizard-field";
export {
default as discourse$models$custom__wizard__field$$default
} from "./discourse/models/custom-wizard-field";
import * as Mod102 from "./discourse/models/custom-wizard-logs";
compatModules["discourse/models/custom-wizard-logs"] = Mod102;

export * as discourse$models$custom__wizard__logs$$__module from "./discourse/models/custom-wizard-logs";
export {
default as discourse$models$custom__wizard__logs$$default
} from "./discourse/models/custom-wizard-logs";
import * as Mod103 from "./discourse/models/custom-wizard-manager";
compatModules["discourse/models/custom-wizard-manager"] = Mod103;

export * as discourse$models$custom__wizard__manager$$__module from "./discourse/models/custom-wizard-manager";
export {
default as discourse$models$custom__wizard__manager$$default
} from "./discourse/models/custom-wizard-manager";
import * as Mod104 from "./discourse/models/custom-wizard-step";
compatModules["discourse/models/custom-wizard-step"] = Mod104;

export * as discourse$models$custom__wizard__step$$__module from "./discourse/models/custom-wizard-step";
export {
default as discourse$models$custom__wizard__step$$default
} from "./discourse/models/custom-wizard-step";
import * as Mod105 from "./discourse/models/custom-wizard";
compatModules["discourse/models/custom-wizard"] = Mod105;

export * as discourse$models$custom__wizard$$__module from "./discourse/models/custom-wizard";
export {
findCustomWizard as discourse$models$custom__wizard$$findCustomWizard,
updateCachedWizard as discourse$models$custom__wizard$$updateCachedWizard,
getCachedWizard as discourse$models$custom__wizard$$getCachedWizard,
default as discourse$models$custom__wizard$$default
} from "./discourse/models/custom-wizard";
import * as Mod106 from "./discourse/routes/admin-wizards-api-show";
compatModules["discourse/routes/admin-wizards-api-show"] = Mod106;

export * as discourse$routes$admin__wizards__api__show$$__module from "./discourse/routes/admin-wizards-api-show";
export {
default as discourse$routes$admin__wizards__api__show$$default
} from "./discourse/routes/admin-wizards-api-show";
import * as Mod107 from "./discourse/routes/admin-wizards-api";
compatModules["discourse/routes/admin-wizards-api"] = Mod107;

export * as discourse$routes$admin__wizards__api$$__module from "./discourse/routes/admin-wizards-api";
export {
default as discourse$routes$admin__wizards__api$$default
} from "./discourse/routes/admin-wizards-api";
import * as Mod108 from "./discourse/routes/admin-wizards-custom-fields";
compatModules["discourse/routes/admin-wizards-custom-fields"] = Mod108;

export * as discourse$routes$admin__wizards__custom__fields$$__module from "./discourse/routes/admin-wizards-custom-fields";
export {
default as discourse$routes$admin__wizards__custom__fields$$default
} from "./discourse/routes/admin-wizards-custom-fields";
import * as Mod109 from "./discourse/routes/admin-wizards-logs-show";
compatModules["discourse/routes/admin-wizards-logs-show"] = Mod109;

export * as discourse$routes$admin__wizards__logs__show$$__module from "./discourse/routes/admin-wizards-logs-show";
export {
default as discourse$routes$admin__wizards__logs__show$$default
} from "./discourse/routes/admin-wizards-logs-show";
import * as Mod110 from "./discourse/routes/admin-wizards-logs";
compatModules["discourse/routes/admin-wizards-logs"] = Mod110;

export * as discourse$routes$admin__wizards__logs$$__module from "./discourse/routes/admin-wizards-logs";
export {
default as discourse$routes$admin__wizards__logs$$default
} from "./discourse/routes/admin-wizards-logs";
import * as Mod111 from "./discourse/routes/admin-wizards-manager";
compatModules["discourse/routes/admin-wizards-manager"] = Mod111;

export * as discourse$routes$admin__wizards__manager$$__module from "./discourse/routes/admin-wizards-manager";
export {
default as discourse$routes$admin__wizards__manager$$default
} from "./discourse/routes/admin-wizards-manager";
import * as Mod112 from "./discourse/routes/admin-wizards-submissions-show";
compatModules["discourse/routes/admin-wizards-submissions-show"] = Mod112;

export * as discourse$routes$admin__wizards__submissions__show$$__module from "./discourse/routes/admin-wizards-submissions-show";
export {
default as discourse$routes$admin__wizards__submissions__show$$default
} from "./discourse/routes/admin-wizards-submissions-show";
import * as Mod113 from "./discourse/routes/admin-wizards-submissions";
compatModules["discourse/routes/admin-wizards-submissions"] = Mod113;

export * as discourse$routes$admin__wizards__submissions$$__module from "./discourse/routes/admin-wizards-submissions";
export {
default as discourse$routes$admin__wizards__submissions$$default
} from "./discourse/routes/admin-wizards-submissions";
import * as Mod114 from "./discourse/routes/admin-wizards-wizard-show";
compatModules["discourse/routes/admin-wizards-wizard-show"] = Mod114;

export * as discourse$routes$admin__wizards__wizard__show$$__module from "./discourse/routes/admin-wizards-wizard-show";
export {
default as discourse$routes$admin__wizards__wizard__show$$default
} from "./discourse/routes/admin-wizards-wizard-show";
import * as Mod115 from "./discourse/routes/admin-wizards-wizard";
compatModules["discourse/routes/admin-wizards-wizard"] = Mod115;

export * as discourse$routes$admin__wizards__wizard$$__module from "./discourse/routes/admin-wizards-wizard";
export {
default as discourse$routes$admin__wizards__wizard$$default
} from "./discourse/routes/admin-wizards-wizard";
import * as Mod116 from "./discourse/routes/admin-wizards";
compatModules["discourse/routes/admin-wizards"] = Mod116;

export * as discourse$routes$admin__wizards$$__module from "./discourse/routes/admin-wizards";
export {
default as discourse$routes$admin__wizards$$default
} from "./discourse/routes/admin-wizards";
import * as Mod117 from "./discourse/routes/custom-wizard-index";
compatModules["discourse/routes/custom-wizard-index"] = Mod117;

export * as discourse$routes$custom__wizard__index$$__module from "./discourse/routes/custom-wizard-index";
export {
default as discourse$routes$custom__wizard__index$$default
} from "./discourse/routes/custom-wizard-index";
import * as Mod118 from "./discourse/routes/custom-wizard-step";
compatModules["discourse/routes/custom-wizard-step"] = Mod118;

export * as discourse$routes$custom__wizard__step$$__module from "./discourse/routes/custom-wizard-step";
export {
default as discourse$routes$custom__wizard__step$$default
} from "./discourse/routes/custom-wizard-step";
import * as Mod119 from "./discourse/routes/custom-wizard";
compatModules["discourse/routes/custom-wizard"] = Mod119;

export * as discourse$routes$custom__wizard$$__module from "./discourse/routes/custom-wizard";
export {
default as discourse$routes$custom__wizard$$default
} from "./discourse/routes/custom-wizard";
import * as Mod120 from "./discourse/services/subscription";
compatModules["discourse/services/subscription"] = Mod120;

export * as discourse$services$subscription$$__module from "./discourse/services/subscription";
export {
default as discourse$services$subscription$$default
} from "./discourse/services/subscription";
import * as Mod121 from "./discourse/templates/admin-wizards-api-show";
compatModules["discourse/templates/admin-wizards-api-show"] = Mod121;

export * as discourse$templates$admin__wizards__api__show$$__module from "./discourse/templates/admin-wizards-api-show";
export {
default as discourse$templates$admin__wizards__api__show$$default
} from "./discourse/templates/admin-wizards-api-show";
import * as Mod122 from "./discourse/templates/admin-wizards-api";
compatModules["discourse/templates/admin-wizards-api"] = Mod122;

export * as discourse$templates$admin__wizards__api$$__module from "./discourse/templates/admin-wizards-api";
export {
default as discourse$templates$admin__wizards__api$$default
} from "./discourse/templates/admin-wizards-api";
import * as Mod123 from "./discourse/templates/admin-wizards-custom-fields";
compatModules["discourse/templates/admin-wizards-custom-fields"] = Mod123;

export * as discourse$templates$admin__wizards__custom__fields$$__module from "./discourse/templates/admin-wizards-custom-fields";
export {
default as discourse$templates$admin__wizards__custom__fields$$default
} from "./discourse/templates/admin-wizards-custom-fields";
import * as Mod124 from "./discourse/templates/admin-wizards-logs-show";
compatModules["discourse/templates/admin-wizards-logs-show"] = Mod124;

export * as discourse$templates$admin__wizards__logs__show$$__module from "./discourse/templates/admin-wizards-logs-show";
export {
default as discourse$templates$admin__wizards__logs__show$$default
} from "./discourse/templates/admin-wizards-logs-show";
import * as Mod125 from "./discourse/templates/admin-wizards-logs";
compatModules["discourse/templates/admin-wizards-logs"] = Mod125;

export * as discourse$templates$admin__wizards__logs$$__module from "./discourse/templates/admin-wizards-logs";
export {
default as discourse$templates$admin__wizards__logs$$default
} from "./discourse/templates/admin-wizards-logs";
import * as Mod126 from "./discourse/templates/admin-wizards-manager";
compatModules["discourse/templates/admin-wizards-manager"] = Mod126;

export * as discourse$templates$admin__wizards__manager$$__module from "./discourse/templates/admin-wizards-manager";
export {
default as discourse$templates$admin__wizards__manager$$default
} from "./discourse/templates/admin-wizards-manager";
import * as Mod127 from "./discourse/templates/admin-wizards-submissions-show";
compatModules["discourse/templates/admin-wizards-submissions-show"] = Mod127;

export * as discourse$templates$admin__wizards__submissions__show$$__module from "./discourse/templates/admin-wizards-submissions-show";
export {
default as discourse$templates$admin__wizards__submissions__show$$default
} from "./discourse/templates/admin-wizards-submissions-show";
import * as Mod128 from "./discourse/templates/admin-wizards-submissions";
compatModules["discourse/templates/admin-wizards-submissions"] = Mod128;

export * as discourse$templates$admin__wizards__submissions$$__module from "./discourse/templates/admin-wizards-submissions";
export {
default as discourse$templates$admin__wizards__submissions$$default
} from "./discourse/templates/admin-wizards-submissions";
import * as Mod129 from "./discourse/templates/admin-wizards-wizard-show";
compatModules["discourse/templates/admin-wizards-wizard-show"] = Mod129;

export * as discourse$templates$admin__wizards__wizard__show$$__module from "./discourse/templates/admin-wizards-wizard-show";
export {
default as discourse$templates$admin__wizards__wizard__show$$default
} from "./discourse/templates/admin-wizards-wizard-show";
import * as Mod130 from "./discourse/templates/admin-wizards-wizard";
compatModules["discourse/templates/admin-wizards-wizard"] = Mod130;

export * as discourse$templates$admin__wizards__wizard$$__module from "./discourse/templates/admin-wizards-wizard";
export {
default as discourse$templates$admin__wizards__wizard$$default
} from "./discourse/templates/admin-wizards-wizard";
import * as Mod131 from "./discourse/templates/admin-wizards";
compatModules["discourse/templates/admin-wizards"] = Mod131;

export * as discourse$templates$admin__wizards$$__module from "./discourse/templates/admin-wizards";
export {
default as discourse$templates$admin__wizards$$default
} from "./discourse/templates/admin-wizards";
import * as Mod132 from "./discourse/templates/custom-wizard-index";
compatModules["discourse/templates/custom-wizard-index"] = Mod132;

export * as discourse$templates$custom__wizard__index$$__module from "./discourse/templates/custom-wizard-index";
export {
default as discourse$templates$custom__wizard__index$$default
} from "./discourse/templates/custom-wizard-index";
import * as Mod133 from "./discourse/templates/custom-wizard-step";
compatModules["discourse/templates/custom-wizard-step"] = Mod133;

export * as discourse$templates$custom__wizard__step$$__module from "./discourse/templates/custom-wizard-step";
export {
default as discourse$templates$custom__wizard__step$$default
} from "./discourse/templates/custom-wizard-step";
import * as Mod134 from "./discourse/templates/custom-wizard";
compatModules["discourse/templates/custom-wizard"] = Mod134;

export * as discourse$templates$custom__wizard$$__module from "./discourse/templates/custom-wizard";
export {
default as discourse$templates$custom__wizard$$default
} from "./discourse/templates/custom-wizard";
export default compatModules;
